import gql from "graphql-tag"

export default gql`
  query providerFolderList($providerId: String!, $parentId: String) {
    providerFolderList(providerId: $providerId, parentId: $parentId) {
      id
      name
      parentId
    }
  }
`
